import React, { useState } from 'react';
import ListOfBoxCardOrders from './listOfBoxOrdersCart';
import ShipmentItems from './shipmentItems';
export default function BoxChooseButton() {
  const [selectedMenuItem, setSelectedMenuItem] = useState('ListOfBoxCardOrders');

  const handleMenuItemClick = (menuItem) => {
    setSelectedMenuItem(menuItem);
  };


  return (
    <div className="flex flex-col items-center w-full lg:mt-10 md:mr-10">
    <div className="w-full">
      {selectedMenuItem === 'ListOfBoxShipmentOrders' && (
        <ShipmentItems
          setSelectedMenuItem={setSelectedMenuItem}
        />
      )}
      {selectedMenuItem === 'ListOfBoxCardOrders' && (
        <ListOfBoxCardOrders
          selectedMenuItem={selectedMenuItem}
          onMenuItemClick={handleMenuItemClick}
        />
      )}
    </div>
  </div>
  );
}
